export default {
  satIdentificationCollection: [],
};
